import MDEditor from "@uiw/react-md-editor";

const priorityColors = {
  Highest:    { color: "#c62828", bg: "#ffebee" },
  High:       { color: "#e65100", bg: "#fff3e0" },
  Normal:     { color: "#2e7d32", bg: "#e8f5e9" },
  Low:        { color: "#1565c0", bg: "#e3f2fd" },
  Nicetohave: { color: "#616161", bg: "#f5f5f5" },
};

const statusColors = {
  Created:     { color: "#1565c0", bg: "#e3f2fd" },
  In_Progress: { color: "#e65100", bg: "#fff3e0" },
  Done:        { color: "#2e7d32", bg: "#e8f5e9" },
  On_Hold:     { color: "#616161", bg: "#f5f5f5" },
  Canceled:    { color: "#c62828", bg: "#ffebee" },
};

const MetaItem = ({ label, value }) => {
  if (!value) return null;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
      <span style={{ fontSize: "0.7rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em", color: "#9e9e9e" }}>{label}</span>
      <span style={{ fontSize: "0.9rem", fontWeight: 500, color: "#212121" }}>{value}</span>
    </div>
  );
};

const TicketView = ({ action }) => {
  if (!action) return null;

  const p = priorityColors[action.priority] || priorityColors.Nicetohave;
  const s = statusColors[action.status] || statusColors.Created;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

      {/* Badges row */}
      <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
        {action.priority && (
          <span style={{ background: p.bg, color: p.color, fontSize: "0.75rem", fontWeight: 700, padding: "4px 12px", borderRadius: "20px" }}>
            {action.priority}
          </span>
        )}
        {action.status && (
          <span style={{ background: s.bg, color: s.color, fontSize: "0.75rem", fontWeight: 700, padding: "4px 12px", borderRadius: "20px" }}>
            {action.status?.replace("_", " ")}
          </span>
        )}
      </div>

      {/* Dates grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "16px", background: "#fff", borderRadius: "10px", padding: "16px", boxShadow: "0 1px 6px rgba(0,0,0,0.06)" }}>
        <MetaItem label="Start" value={action.start} />
        <MetaItem label="End" value={action.end} />
        <MetaItem label="Deadline" value={action.deadline} />
      </div>

      {/* Company / Person */}
      {(action.kunde || action.person) && (
        <div style={{ display: "flex", gap: "16px" }}>
          {action.kunde && (
            <div style={{ flex: 1, background: "#fff", borderRadius: "10px", padding: "16px", boxShadow: "0 1px 6px rgba(0,0,0,0.06)" }}>
              <span style={{ fontSize: "0.7rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em", color: "#9e9e9e" }}>Company</span>
              <div style={{ fontWeight: 700, fontSize: "0.95rem", color: "#212121", marginTop: "4px" }}>{action.kunde.firmenname}</div>
              {action.kunde.bemerkung && <div style={{ fontSize: "0.82rem", color: "#757575", marginTop: "2px" }}>{action.kunde.bemerkung}</div>}
            </div>
          )}
          {action.person && (
            <div style={{ flex: 1, background: "#fff", borderRadius: "10px", padding: "16px", boxShadow: "0 1px 6px rgba(0,0,0,0.06)" }}>
              <span style={{ fontSize: "0.7rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em", color: "#9e9e9e" }}>Person</span>
              <div style={{ fontWeight: 700, fontSize: "0.95rem", color: "#212121", marginTop: "4px" }}>{action.person.vorname} {action.person.name}</div>
            </div>
          )}
        </div>
      )}

      {/* Description */}
      {action.beschreibung && (
        <div style={{ background: "#fff", borderRadius: "10px", padding: "16px", boxShadow: "0 1px 6px rgba(0,0,0,0.06)" }}>
          <span style={{ fontSize: "0.7rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em", color: "#9e9e9e", display: "block", marginBottom: "8px" }}>Description</span>
          <div data-color-mode="light">
            <MDEditor.Markdown source={action.beschreibung} style={{ fontSize: "0.9rem", background: "transparent" }} />
          </div>
        </div>
      )}

      {/* Tags */}
      {action.tags && action.tags.length > 0 && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
          {action.tags.map((tag) => (
            <span key={tag.id} style={{ background: "#e8f5e9", color: "#2e7d32", fontSize: "0.75rem", fontWeight: 600, padding: "4px 12px", borderRadius: "20px" }}>
              {tag.name}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default TicketView;
